module.exports = __webpack_public_path__ + "img/firefox.d85dc16d.svg";